import { useState } from "react";

export default function GeneralSettingsPanel() {
  const [settings, setSettings] = useState({
    platformName: "FloraIQ",
    orgName: "FloraIQ Tecnologia Ambiental Ltda",
    email: "contato@floraiq.com.br",
    phone: "(62) 3600-1000",
    website: "https://floraiq.com.br",
    defaultCity: "Goiânia",
    defaultState: "GO",
    language: "pt-BR",
    timezone: "America/Sao_Paulo",
    dateFormat: "DD/MM/YYYY",
    unit: "metric",
    orgStatus: "ativo",
  });

  const handleChange = (field: string, value: string) => {
    setSettings((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="space-y-5">
      <div className="bg-white rounded-xl border border-background-200/70 p-5">
        <h3 className="text-sm font-semibold text-foreground-900 mb-4">Informações da organização</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Field label="Nome da plataforma" value={settings.platformName} onChange={(v) => handleChange("platformName", v)} />
          <Field label="Nome da organização" value={settings.orgName} onChange={(v) => handleChange("orgName", v)} />
          <Field label="E-mail institucional" value={settings.email} onChange={(v) => handleChange("email", v)} type="email" />
          <Field label="Telefone" value={settings.phone} onChange={(v) => handleChange("phone", v)} />
          <Field label="Website" value={settings.website} onChange={(v) => handleChange("website", v)} />
          <Field label="Status da organização" value={settings.orgStatus} onChange={(v) => handleChange("orgStatus", v)} />
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Município padrão</label>
            <select className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" value={settings.defaultCity} onChange={(e) => handleChange("defaultCity", e.target.value)}>
              <option value="Goiânia">Goiânia</option>
              <option value="Anápolis">Anápolis</option>
              <option value="Aparecida de Goiânia">Aparecida de Goiânia</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">UF padrão</label>
            <select className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" value={settings.defaultState} onChange={(e) => handleChange("defaultState", e.target.value)}>
              <option value="GO">GO</option>
              <option value="DF">DF</option>
              <option value="MT">MT</option>
              <option value="TO">TO</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Idioma</label>
            <select className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" value={settings.language} onChange={(e) => handleChange("language", e.target.value)}>
              <option value="pt-BR">Português (Brasil)</option>
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Fuso horário</label>
            <select className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" value={settings.timezone} onChange={(e) => handleChange("timezone", e.target.value)}>
              <option value="America/Sao_Paulo">America/Sao_Paulo (GMT-3)</option>
              <option value="America/Manaus">America/Manaus (GMT-4)</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Formato de data</label>
            <select className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" value={settings.dateFormat} onChange={(e) => handleChange("dateFormat", e.target.value)}>
              <option value="DD/MM/YYYY">DD/MM/YYYY</option>
              <option value="MM/DD/YYYY">MM/DD/YYYY</option>
              <option value="YYYY-MM-DD">YYYY-MM-DD</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Unidade de medida</label>
            <select className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" value={settings.unit} onChange={(e) => handleChange("unit", e.target.value)}>
              <option value="metric">Métrico (m, cm, kg)</option>
              <option value="imperial">Imperial (ft, in, lb)</option>
            </select>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-background-200/70 p-5">
        <h3 className="text-sm font-semibold text-foreground-900 mb-4">Logo institucional</h3>
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-xl bg-primary-50 flex items-center justify-center border border-primary-200">
            <span className="text-primary-700 font-bold font-heading text-lg">FI</span>
          </div>
          <div>
            <button className="px-4 py-2 text-sm font-semibold text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors whitespace-nowrap">
              <i className="ri-upload-line w-4 h-4 inline-flex items-center justify-center mr-1" />
              Alterar logo
            </button>
            <p className="text-xs text-foreground-400 mt-1">PNG ou SVG, mínimo 256x256px</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text" }: { label: string; value: string; onChange: (v: string) => void; type?: string }) {
  return (
    <div>
      <label className="block text-xs font-medium text-foreground-600 mb-1">{label}</label>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" />
    </div>
  );
}